<template>
    <a-tree-select
            :allowClear="true"
            :multiple="multiple"
            :value="treeValue"
            class="tree"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="dataList"
            :replaceFields="{title:'name', key:'id', value: 'id'}"
            tree-default-expand-all
            @change="onchange"/>
</template>

<script>
    export default {
        props:{
            treeValue:{
            },
            dataList:{
                type:Array,
                default(){
                    return []
                }
            },
            // 是否多选
            multiple:{
                type:Boolean,
                default:false
            }
        },
        methods:{
            onchange(value){
                this.$emit('update:treeValue',value);
                this.$emit('change',value)
            }
        },
    }
</script>

<style scoped>
    .tree{
        width: 100%
    }
</style>
